import * as React from 'react'
import { theme } from '../../theme'

interface Props {
	selectedAction: string
	onActionChange: (action: string) => void
}

export const ActionSelector = ({ selectedAction, onActionChange }: Props) => {
	return (
		<div
			style={{
				padding: theme.spacing.md,
				paddingRight: '56px',
				position: 'relative',
				display: 'flex',
				alignItems: 'center',
				gap: theme.spacing.md,
				marginBottom: '8px',
				width: '95%',
				margin: '0 auto',
			}}
		>
			<h2
				style={{
					margin: 0,
					marginBottom: '8px',
					fontSize: '15px',
					color: '#666666',
					whiteSpace: 'nowrap',
				}}
			>
				Selection Editing Action from the dropdown
			</h2>
			<select
				value={selectedAction}
				style={{
					padding: '8px 12px',
					borderRadius: theme.borderRadius.sm,
					border: `1px solid ${theme.colors.border}`,
					backgroundColor: theme.colors.background,
					color: theme.colors.text.primary,
					fontSize: '14px',
					flex: 1,
					minWidth: 0,
					cursor: 'pointer',
					outline: 'none',
				}}
				onChange={(e) => onActionChange(e.target.value)}
			>
				<option value="adjust">Adjust Image position and dimensions with AI</option>
				<option value="add">Add objects or elements to Image using AI prompt</option>
				<option value="erase">Erase objects and elements from picture using AI</option>
				<option value="disclaimer">Add disclaimer texts to Image</option>
				<option value="create">Create new images using AI prompt</option>
			</select>
			<div
				style={{
					position: 'absolute',
					bottom: '-4px',
					left: '50%',
					transform: 'translateX(-50%)',
					width: '95%',
					height: '4px',
					background: 'rgba(47, 123, 118, 0.3)',
					borderRadius: '2px',
				}}
			/>
		</div>
	)
}
